<template>
  <div id="app">
    <layout></layout>

  </div>
</template>

<script>
import Layout from '@/components/layout'
export default {
  name: 'App',
  components: {
    Layout
  }
}
</script>

<style>
  @font-face{
    font-family:hanyi;
    src: url("./assets/fonts/hanyi.ttf") ;
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }	
  @font-face{
    font-family:'hanyi75';
    src: url("./assets/fonts/hanyi75.ttf") ;
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }		
  html,body{
    width:100%;
    padding:0;
    margin:0;
    overflow: hidden;
    font-family: hanyi;
  }
	
  ul,h3,h4{
    padding:0;
    margin:0;
  }
  ul li{
    list-style: none;
  }
  .el-vue-search-box-container .search-tips {
    max-height: 200px;
    width:100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue